import { useMemo } from 'react';
import usePersonalizationStrategy from 'personalization-lib/hooks/variants/usePersonalizationStrategy';
import { getFailedAiVariantsFromStrategy, getInProgressAiVariantsFromStrategy } from 'personalization-lib/utils/personalizationStrategy/aiVariants';

/**
 * A hook to get the AI execution status for a given strategy.
 * @param strategyId (optional) Strategy to check the statuses of. Will skip if no id provided
 * @param userId (optional) User ID to filter execution status checks to, if not provided, will return counts for all users
 * @returns An object containing the number of in-progress and failed AI execution requests, as well as loading and error states
 */
const useAiExecutionStatus = (strategyId, userId) => {
  const {
    strategy,
    loading,
    error
  } = usePersonalizationStrategy(strategyId);
  return useMemo(() => ({
    requestsInProgress: getInProgressAiVariantsFromStrategy(strategy, userId).length,
    requestsFailed: getFailedAiVariantsFromStrategy(strategy, userId).length,
    loading,
    error
  }), [strategy, userId, loading, error]);
};
export default useAiExecutionStatus;